import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import PracticeService from '../../../services/practice-service';

const useRunPractice = () => {
  return useMutation({
    mutationFn: ({
      practiceId,
      userMessage,
      action,
      docId,
    }: {
      practiceId: number;
      userMessage: string;
      action?: string;
      docId: number;
    }) => PracticeService.runPractice(practiceId, userMessage, action, docId),
    onError: (error) => {
      toast.error('Failed to run practice. Please try again.');
      console.error('Failed to run practice:', error);
    },
  });
};

export default useRunPractice;
